(function () {
    /* Smooth scroll for on-page anchor links */
    document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href^="#lp-"]');
        if (!a) return;
        var target = document.querySelector(a.getAttribute('href'));
        if (target) {
            e.preventDefault();
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    });

    /* Lead form (scoped per section) */
    window.lpSubmitLead = function (e) {
        e.preventDefault();
        var form = e.target;
        if (!form.querySelector('input[type="radio"]:checked')) {
            alert('Please select your property type.');
            return;
        }

        var btn = form.querySelector('button[type="submit"]');
        btn.textContent = 'Sending…';
        btn.disabled = true;

        setTimeout(function () {
            var card = form.closest('.promo-card');
            if (!card) return;
            var wrap = card.querySelector('.js-hw-lead-wrap');
            var success = card.querySelector('.js-hw-lead-success');
            if (wrap) wrap.style.display = 'none';
            if (success) {
                success.style.display = 'block';
                success.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 800);
    };

    /* BEC booking form */
    window.lpSubmitBec = function (e) {
        e.preventDefault();
        var form = e.target;
        var btn = form.querySelector('.js-hw-bec-btn');
        if (!btn) return;
        btn.textContent = 'Confirming…';
        btn.disabled = true;

        setTimeout(function () {
            btn.textContent = "✓ Appointment Confirmed — We'll be in touch!";
            btn.style.background = '#34A853';
            btn.style.borderColor = '#34A853';
        }, 800);
    };

    /* BEC section: Shopify-hosted (data-video-hosted-src) or YouTube / Vimeo on .js-hw-vid-wrap */
    window.lpLoadVideo = function (wrapper) {
        var hostedSrc = (wrapper.getAttribute('data-video-hosted-src') || '').trim();
        if (hostedSrc) {
            var vid = document.createElement('video');
            vid.setAttribute('controls', '');
            vid.setAttribute('autoplay', '');
            vid.setAttribute('playsinline', '');
            var poster = (wrapper.getAttribute('data-video-poster') || '').trim();
            if (poster) {
                vid.setAttribute('poster', poster);
            }
            vid.style.cssText = 'width:100%;height:100%;object-fit:contain;background:#000;';
            vid.src = hostedSrc;
            wrapper.innerHTML = '';
            wrapper.appendChild(vid);
            vid.play().catch(function () {});
            return;
        }
        var youtubeId = (wrapper.getAttribute('data-youtube-id') || '').trim();
        var vimeoId = (wrapper.getAttribute('data-vimeo-id') || '').trim();
        if (!youtubeId && !vimeoId) {
            alert('Add a video in the theme editor: Shopify-hosted, or YouTube/Vimeo (BEC section).');
            return;
        }
        var iframe = document.createElement('iframe');
        if (youtubeId) {
            iframe.src = 'https://www.youtube.com/embed/' + youtubeId + '?autoplay=1&rel=0';
        } else {
            iframe.src = 'https://player.vimeo.com/video/' + vimeoId + '?autoplay=1&dnt=1';
        }
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
        iframe.allowFullscreen = true;
        iframe.style.cssText = 'width:100%;height:100%;border:none;';
        wrapper.innerHTML = '';
        wrapper.appendChild(iframe);
    };

    /* Partner tabs — scope to nearest .lp-partners */
    window.lpSwitchTab = function (btn, tab) {
        var root = btn.closest('.lp-partners');
        if (!root) return;
        root.querySelectorAll('.ptab').forEach(function (t) {
            var on = t.getAttribute('data-tab') === tab;
            t.classList.toggle('active', on);
            t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('.ptrs-panel').forEach(function (p) {
            p.style.display = p.getAttribute('data-tab') === tab ? 'block' : 'none';
        });
    };

    /* BEC date min = tomorrow */
    document.querySelectorAll('.js-hw-bec-date').forEach(function (bdate) {
        var d = new Date();
        d.setDate(d.getDate() + 1);
        bdate.min = d.toISOString().split('T')[0];
    });

    /* StoreRocket script once */
    if (!window.__hwStoreRocketScript && document.querySelector('[data-storerocket-id]')) {
        window.__hwStoreRocketScript = true;
        var a = document.createElement('script');
        a.type = 'text/javascript';
        a.async = true;
        a.src = 'https://cdn.storerocket.io/js/widget-mb.js';
        var b = document.getElementsByTagName('script')[0];
        b.parentNode.insertBefore(a, b);
    }

    /* Scroll-reveal */
    var lpRevEls = document.querySelectorAll('.exhw-lp .lp-reveal');
    var lpRevObs = new IntersectionObserver(
        function (entries) {
            entries.forEach(function (e) {
                if (e.isIntersecting) e.target.classList.add('lp-vis');
            });
        },
        { threshold: 0.1 }
    );
    lpRevEls.forEach(function (el) {
        lpRevObs.observe(el);
    });
})();
